import { OrganizationGenqlSelection } from '@rematter/frontend-lib-api-client';

export const simpleOrganizationFragment = {
  id: true,
  name: true,
  domain: true,
  createdAt: true,
  updatedAt: true,
  onboardedAt: true,
  timezone: true,
  users: {
    id: true,
  },
} satisfies OrganizationGenqlSelection;

export const detailedOrganizationFragment = {
  id: true,
  name: true,
  domain: true,
  createdAt: true,
  updatedAt: true,
  onboardedAt: true,
  timezone: true,
  idpId: true,
  users: {
    id: true,
    firstName: true,
    lastName: true,
    email: true,
  },
  facilities: {
    id: true,
    facilityName: true,
  },
  facilityGroups: {
    id: true,
    name: true,
  },
} satisfies OrganizationGenqlSelection;
